import React from 'react'

function Pagetitle(props) {
  return (
        <div className="tf-page-title">
            <div className="container-full">
                <div className="heading text-center">{props.title}</div>
            </div>
        </div>
  )
}

export default Pagetitle